<script setup lang="ts">
import { computed } from 'vue'
import { useField } from 'vee-validate'
import Calendar from 'primevue/calendar';
import { formatedDate } from '@/constants';
import InputText from 'primevue/inputtext';


const props = defineProps<{
  modelValue?: any
  inputName: string
  disabled?: boolean
}>()

const emit = defineEmits(['update:modelValue'])

const { value, errorMessage } = useField<any>(props.inputName);

const computedValue = computed({
  get: () => props.modelValue || null,
  set: (newVal: any) => {
    value.value = newVal;
    emit('update:modelValue', newVal);
  }
})
// This computed is for formatting the date when 'disabled' is true
const formatedKnittedDate = computed(() => {
  // Format the date only if it's present and valid, else return an empty string
  return computedValue.value ? formatedDate(computedValue.value) : '';
})


</script>

<template>
  <div class="flex flex-col gap-2">
    <label for="dateReturned">Date Returned:</label>
    <InputText v-if="disabled" v-model="formatedKnittedDate" :disabled="disabled" />
    <Calendar
      v-else
      id="dateReturned"
      placeholder=""
      :invalid="!!errorMessage"
      v-model="computedValue"
      showIcon iconDisplay="input"
      :disabled="disabled"
      dateFormat="dd/mm/yy"
    />
  </div>
</template>

<style scoped>

</style>